import { fetchLists } from './bao-swym.js'

class WishlistSelect extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = []
    }

    window.SwymCallbacks.push(() => {
      fetchLists().then(lists => {
        this.populateWishlists(lists)
      })
    })
  }

  setupListeners () {
    super.setupListeners()

    this.toggleExpanded = this.toggleExpanded.bind(this)
    this.selectWishlist = this.selectWishlist.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleFocusOut = this.handleFocusOut.bind(this)

    document.addEventListener('swym:lists-updated', () => {
      this.populateWishlists()
    })

    this.listeners.add(this.trigger, 'click', this.toggleExpanded)
    this.listeners.add(this, 'keydown', this.handleKeyDown)
    this.listeners.add(this, 'focusout', this.handleFocusOut)
  }

  setExpanded (expanded) {
    const value = expanded ? 'true' : 'false'

    this.setAttribute('aria-expanded', value)
    this.trigger.setAttribute('aria-expanded', value)
  }

  handleKeyDown (event) {
    if (event.key !== 'Escape' || !this.expanded) return

    this.setExpanded(false)
    this.trigger.focus()
  }

  handleFocusOut (event) {
    if (this.contains(event.relatedTarget)) return

    this.setExpanded(false)
  }

  populateWishlists (lists) {
    lists.forEach(list => {
      const option = document.createElement('option')
      option.value = list.lid
      option.innerText = list.lname

      this.select.appendChild(option)

      const button = document.createElement('button')
      button.classList.add('btn-Button', 'prd-DetailVariants_DropdownOption')
      button.dataset.lid = list.lid
      button.value = list.lname
      button.addEventListener('click', this.selectWishlist)

      const span = document.createElement('span')
      span.classList.add('prd-DetailVariants_VariantLabel')
      span.innerText = list.lname

      button.appendChild(span)

      this.dropdown.appendChild(button)
    })
  }

  toggleExpanded () {
    const willExpand = !this.expanded

    this.setExpanded(willExpand)

    if (willExpand) this.dropdown.querySelector('button')?.focus()
  }

  selectWishlist (event) {
    const lid = event.currentTarget.dataset.lid

    this.dataset.lid = lid
    this.dataset.wishlistName = event.currentTarget.innerText
    this.select.value = lid
    this.setExpanded(false)
    this.trigger.focus()

    if (this.externalEls.variantSelect.element.value) {
      this.externalEls.addToWishList.element.removeAttribute('disabled')
    } else {
      this.externalEls.addToWishList.element.setAttribute('disabled', true)
    }
  }

  get select () {
    return this.els.select.element
  }

  get dropdown () {
    return this.els.dropdown.element
  }

  get expanded () {
    return this.getAttribute('aria-expanded') === 'true'
  }

  get trigger () {
    return this.els.trigger.element
  }
}

if (!customElements.get('wishlist-select')) {
  customElements.define('wishlist-select', WishlistSelect)
}
